<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect class="svg_check_border" width="24" height="24" rx="3" fill="currentColor"/>
<path class="svg_check" d="M4.54053 13.2974L7.45945 16.0339M10.3784 18.1622L19.4594 6.48657" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
